/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DivisionDto as DigiworkMaitreDPosDtoDivisionDto } from '../../models/Digiwork/MaitreD/Pos/DTO/division-dto';
import { UpdateDivisionDto as DigiworkMaitreDPosDtoDivisionsUpdateDivisionDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Divisions/update-division-dto';

export interface UpdateDivision$Params {
  divisionId: string;
      body?: DigiworkMaitreDPosDtoDivisionsUpdateDivisionDto
}

export function updateDivision(http: HttpClient, rootUrl: string, params: UpdateDivision$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoDivisionDto>> {
  const rb = new RequestBuilder(rootUrl, updateDivision.PATH, 'put');
  if (params) {
    rb.path('divisionId', params.divisionId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoDivisionDto>;
    })
  );
}

updateDivision.PATH = '/api/divisions/{divisionId}';
